export const TestimonialCard = {
  flow: 'y', gap: 'A', padding: 'C', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
  transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)',
  ':hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 40px rgba(0,0,0,0.12)' },
  QuoteIcon: { text: '{{ u201c | polyglot }}', fontSize: 'E', fontWeight: '800', color: 'teal', lineHeight: '0.8', marginBottom: '-Z' },
  QuoteText: { text: (el, s) => s.quote, fontSize: 'A', color: 'inkSubtle', lineHeight: '1.7', fontStyle: 'italic' },
  StarRow: { flow: 'x', gap: 'X',
    StarIcon1: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' },
    StarIcon2: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' },
    StarIcon3: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' },
    StarIcon4: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' },
    StarIcon5: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'amber' }
  },
  ClinicInfo: { flow: 'y', gap: 'X', marginTop: 'Z',
    ClinicName: { text: (el, s) => s.clinic, fontSize: 'Z', fontWeight: '700', color: 'inkText' },
    ClinicLocation: { text: (el, s) => s.location, fontSize: 'Y', color: 'inkMuted' }
  }
}
